<template>
  <legend class="c-legend">
    <slot/>
  </legend>
</template>

<style lang="scss">
  .c-legend {
    font-size: 1.5rem;
    font-weight: $font-weight-medium;
    margin-bottom: .5rem;
    color: $title-fg;
  }
</style>